import React, { useState, useRef, useEffect } from "react";

import { InsideParallaxImage } from "components/Image/Index";

import { Parallax } from "react-scroll-parallax";

import classNames from "classnames";
import * as fromProjects from "store/Projects";

import { a } from "@react-spring/web";
import { useIntersect } from "hooks/useIntersect";
import { useAnimateInTrail } from "hooks/useAnimateInTrail";
import { initialOffset } from "components/Animations/SpringProperties/SpringProperties";

interface IProps {
  animationReady: boolean;
  bodyContent: object;
  alignRight: boolean;
  verticallyCentreSectionTitle(): any;
}

export const OverlappingImages: React.FC<IProps> = ({
  animationReady,
  alignRight,
  verticallyCentreSectionTitle,
  ...props
}) => {
  const bodyContent: fromProjects.IContentOverlappingImagesSection =
    props.bodyContent as fromProjects.IContentOverlappingImagesSection;
  const wrapper = useRef(null);
  const [width, setWidth] = useState(1000);

  useEffect(() => {
    const updateWidth = () => {
      setWidth(wrapper.current.getBoundingClientRect().width);
    };

    updateWidth();
    verticallyCentreSectionTitle();

    // Setup event listeners on initial mount to keep the  dimensions of the hero updated
    window.addEventListener("resize", updateWidth);

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  const handleRef = (node) => {
    wrapper.current = node;
    inViewRef(node);
  };

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const [animateInTrail] = useAnimateInTrail(inView, 3);

  const firstImageStyles = {
    opacity: animateInTrail[1].active,
    transform: animateInTrail[1].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  const secondImageStyles = {
    opacity: animateInTrail[0].active,
    transform: animateInTrail[0].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  const thirdImageStyles = {
    opacity: animateInTrail[2].active,
    transform: animateInTrail[2].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  return (
    <div
      ref={handleRef}
      className={classNames("overlappingImagesWrapper", { alignRight })}
    >
      <div className="imageWrapper">
        <a.figure className="mainImage" style={firstImageStyles}>
          <InsideParallaxImage
            heightRatio={bodyContent.image[0].heightRatio}
            src={"/assets/images/work/" + bodyContent.image[0].url}
            alt={bodyContent.image[0].alt}
            animateImageIn={true}
            animationType={"fadeIn"}
          />
        </a.figure>
        <Parallax
          y={[
            -0.01171875 * width + "px", // 2560 => 30
            0.05468875 * width + "px", // 2560 => 140
          ]}
          tagOuter="figure"
          className="overlay topLeft"
        >
          <a.div className="parallaxInner" style={secondImageStyles}>
            <InsideParallaxImage
              heightRatio={bodyContent.image[1].heightRatio}
              src={"/assets/images/work/" + bodyContent.image[1].url}
              alt={bodyContent.image[1].alt}
              animateImageIn={true}
              animationType={"fadeIn"}
            />
          </a.div>
        </Parallax>
        <Parallax
          y={[
            -0.03125 * width + "px", // 2560 => 80
            0.03125 * width + "px", // 2560 => 80
          ]}
          tagOuter="figure"
          className="overlay bottomRight"
        >
          <a.div className="parallaxInner" style={thirdImageStyles}>
            <InsideParallaxImage
              heightRatio={bodyContent.image[2].heightRatio}
              src={"/assets/images/work/" + bodyContent.image[2].url}
              alt={bodyContent.image[2].alt}
              animateImageIn={true}
              animationType={"fadeIn"}
            />
          </a.div>
        </Parallax>
      </div>
    </div>
  );
};
